(function (skyward, $)
{
    "use strict";

    skyward.printScreen = skyward.printScreen || {};

    $(function ()
    {
        $("#printScreen").debounce("click", capture);
    });

    var capture = async function ()
    {
        const doc = $(window.document);
        const scrollableData = getScrollableData(doc);

        const data =
        {
            html: skyward.extensions.encodeHtml(skyward.htmlgatherer.getOuterHtml(await captureHtml(doc))),
            windowWidth: skyward.window.clientWidth > 0 ? skyward.window.clientWidth : $(window).width(),
            windowHeight: skyward.window.clientHeight > 0 ? skyward.window.clientHeight : $(window).height(),
            ScrollableElements: scrollableData
        };

        skyward.printScreen.launchWorkflow(skyward.global.virtualDir + "Common/PrintScreen/PrintScreen", { data: JSON.stringify(data) });
    };

    skyward.printScreen.launchWorkflow = function (url, data)
    {
        $.ajax(
            {
                url: url,
                type: "POST",
                dataType: "viewparthtml",
                data: data,
                success: function (html)
                {
                    const popupId = "popup" + skyward.window.getNextPopupId();
                    const popupContent = $("<div/>", { class: "popup workflowPopup", id: popupId, html: html });

                    skyward.modalLayer.newModalLayer(popupContent, null, { closeOnClick: false, closeOnEscape: false, closeOnRecordSelected: false });
                    skyward.window.popupList.push(popupContent);
                    skyward.window.notifyDOMLoad("#" + popupId);
                }
            });
    };

    var captureHtml = async function (doc)
    {
        var options = { stripJavaScript: true };
        var htmlNode = await skyward.htmlgatherer.getNode(doc.find("html"), options);
        return htmlNode;
    };

    const getScrollableData = function (document)
    {
        var getUniqueSelector = function (targetElem)
        {
            var selector = [];
            for (var elem = targetElem; elem.parentElement !== null; elem = elem.parentElement)
            {
                var id = elem.getAttribute("id");
                if (id !== null)
                {
                    selector.unshift("#" + id);
                    return selector.join(">");
                }
                selector.unshift(":nth-child(" + (getPosition(elem) + 1) + ")");
            }
            selector.unshift(":root");
            return selector.join(">");

            function getPosition(elem)
            {
                var parent = elem.parentElement;
                for (var i = 0; i < parent.childElementCount; i++)
                {
                    if (parent.children[i] === elem)
                    {
                        return i;
                    }
                }
            }
        };

        var getElementScrollableInformation = function (doc)
        {
            var scrollables = [];
            var addScrollable = function (element, selector)
            {
                var scrollable = $(element);
                var scrollTop = scrollable.scrollTop();
                var scrollLeft = scrollable.scrollLeft();

                if (scrollTop === 0 && scrollLeft === 0)
                {
                    return;
                }

                scrollables.push({ Selector: selector, Top: Math.trunc(scrollTop), Left: Math.trunc(scrollLeft) });
            };
            // Using '*' to grab all elements, as searching by :scrollable excludes overflow: hidden elements.
            doc.find('*').each(function () { addScrollable(this, getUniqueSelector(this)); });
            // The browser might use html or body for document scrolling; the PDF renderer uses body
            // and doesn't support document.scrollingElement
            addScrollable(doc, "body");

            return scrollables;
        };

        return getElementScrollableInformation(document);
    };

    var customPrintScreen = async function ()
    {
        var button = $(this);
        var buttonData = button.data();
        const postData = buttonData;

        if (buttonData.includePageHtml == true)
        {
            const doc = $(window.document);
            const html = await captureHtml(doc);
            postData.html = skyward.extensions.encodeHtml(skyward.htmlgatherer.getOuterHtml(html));
        }

        skyward.printScreen.launchWorkflow(skyward.global.virtualDir + buttonData.module + "/" + buttonData.controller + "/" + buttonData.action, postData);
    };

    var events =
    {
        'customPrintScreen': customPrintScreen
    };

    //Bootstrap

    if (skyward.events)
    {
        skyward.events.registerEvents('printScreen', events);
    }

}(window.skyward = window.skyward || {}, window.jQuery));